// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, "[data-v-614d3c64] .alert-success{border-color:#24cf94;color:#109e6d}", ""]);
// Exports
module.exports = exports;
